import { createStore, createLogger } from 'vuex';
// import createPersistedState from 'vuex-persistedstate';

import { store as personaldaten, PersonaldatenStore, State as PersonaldatenState } from '@/modules/ewerp/store/modules/Personaldaten';
import { store as energiezaehler, EnergiezaehlerStore, State as EnergiezaehlerState } from '@/modules/ewerp/store/modules/Energiezaehler';
import { store as bestandskontrolle, BestandskontrolleStore, State as BestandskontrolleState } from '@/modules/ewerp/store/modules/Lager/Bestandskontrolle';
import { store as lager, LagerStore, State as LagerState } from '@/modules/ewerp/store/modules/Lager/Lager';
import { store as lagerMaterial, LagerMaterialStore, State as LagerMaterialState } from '@/modules/ewerp/store/modules/Lager/LagerMaterial';
import { store as mitarbeiter, MitarbeiterStore, State as MitarbeiterState } from '@/modules/ewerp/store/modules/Lager/Mitarbeiter';
import { store as planung, PlanungStore, State as PlanungState } from '@/modules/ewerp/store/modules/Lager/Planung';
import { store as printdata, PrintdataStore, State as PrintdataState } from '@/modules/ewerp/store/modules/Lager/Printdata';
import { store as maschinen, MaschinenStore, State as MaschinenState } from '@/modules/ewerp/store/modules/Pps/Maschinen';
import { store as ppsMaterial, PpsMaterialStore, State as PpsMaterialState } from '@/modules/ewerp/store/modules/Pps/Material';
import { store as personal, PersonalStore, State as PersonalState } from '@/modules/ewerp/store/modules/Pps/Personal';
import { store as produktionsstatus, ProduktionsstatusStore, State as ProduktionsstatusState } from '@/modules/ewerp/store/modules/Pps/Produktionsstatus';

export type RootState = {
  personaldaten: PersonaldatenState;
  energiezaehler: EnergiezaehlerState;
  bestandskontrolle: BestandskontrolleState;
  lager: LagerState;
  lagerMaterial: LagerMaterialState;
  mitarbeiter: MitarbeiterState;
  planung: PlanungState;
  printdata: PrintdataState;
  maschinen: MaschinenState;
  ppsMaterial: PpsMaterialState;
  personal: PersonalState;
  produktionsstatus: ProduktionsstatusState;
};

export type Store = PersonaldatenStore<Pick<RootState, 'personaldaten'>> &
  EnergiezaehlerStore<Pick<RootState, 'energiezaehler'>> &
  BestandskontrolleStore<Pick<RootState, 'bestandskontrolle'>> &
  LagerStore<Pick<RootState, 'lager'>> &
  LagerMaterialStore<Pick<RootState, 'lagerMaterial'>> &
  MitarbeiterStore<Pick<RootState, 'mitarbeiter'>> &
  PlanungStore<Pick<RootState, 'planung'>> &
  PrintdataStore<Pick<RootState, 'printdata'>> &
  MaschinenStore<Pick<RootState, 'maschinen'>> &
  PpsMaterialStore<Pick<RootState, 'ppsMaterial'>> &
  PersonalStore<Pick<RootState, 'personal'>> &
  ProduktionsstatusStore<Pick<RootState, 'produktionsstatus'>>;

const debug = process.env.NODE_ENV !== 'production';
const plugins = debug ? [createLogger({})] : [];

// plugins.push(createPersistedState({ storage: window.sessionStorage }));

export const store = createStore({
  plugins,
  modules: {
    personaldaten,
    energiezaehler,
    bestandskontrolle,
    lager,
    lagerMaterial,
    mitarbeiter,
    planung,
    printdata,
    maschinen,
    ppsMaterial,
    personal,
    produktionsstatus,
  },
});

export function useStore(): Store {
  return store as Store;
}
